import './App.css';
import { BuilderComponent } from '@builder.io/react';

function App() {
  return (
    <div className="App">
      <BuilderComponent model="page" />
    </div>
  );
}

export default App;
